/**
 * A chat composer that grows with what is typed, up to `maxRows` lines, then scrolls inside itself (help chat on the
 * extension and the dashboard, decision 7 of docs/prototypes/help-chat-run-workflow). Both composers call this one
 * hook so the two cannot drift. CSS `field-sizing: content` would do it natively, but the dashboard also runs in
 * browsers without it, so the height is set from scrollHeight.
 */
import { useLayoutEffect } from 'react';
/** The border-box height for `scrollHeight` (content plus padding), capped at `maxRows` lines. */
export function autoGrowHeight({ scrollHeight, lineHeight, paddingY, borderY, maxRows }) {
    const max = lineHeight * maxRows + paddingY;
    return scrollHeight > max
        ? { height: max + borderY, overflowY: 'auto' }
        : { height: scrollHeight + borderY, overflowY: 'hidden' };
}
const px = (v) => Number.parseFloat(v) || 0;
/** Resize `ref`'s textarea whenever `value` changes. A `normal` line height reads as 1.25 times the font size. */
export function useAutoGrowTextarea(ref, value, maxRows = 4) {
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const cs = getComputedStyle(el);
        const lineHeight = cs.lineHeight === 'normal' ? px(cs.fontSize) * 1.25 : px(cs.lineHeight);
        el.style.height = 'auto';
        const next = autoGrowHeight({
            scrollHeight: el.scrollHeight, lineHeight, maxRows,
            paddingY: px(cs.paddingTop) + px(cs.paddingBottom),
            borderY: px(cs.borderTopWidth) + px(cs.borderBottomWidth),
        });
        el.style.height = `${next.height}px`;
        el.style.overflowY = next.overflowY;
    }, [ref, value, maxRows]);
}
//# sourceMappingURL=useAutoGrowTextarea.js.map